import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRegisterInlineFieldEditor, useWasUndoRedoEventWithData, useDataTokenFormat, parseLoadingDependencies } from '../lib/InlineFieldEditingHooks';
import { getModifiedPathsWaitingToSave } from 'ContentEditorUI/redux/selectors/crmObjectEditingSelectors';
const ReadOnlyFieldEditor = ({
  node,
  currentValue,
  moduleName
}) => {
  useRegisterInlineFieldEditor(moduleName);
  const wasUndoRedo = useWasUndoRedoEventWithData(currentValue);
  const formattedValue = useDataTokenFormat(node, currentValue);

  // Parse loading dependencies from the node's hs-data-token-loading-dependencies attribute
  const loadingDependencies = useMemo(() => {
    return parseLoadingDependencies(node);
  }, [node]);

  // Get modified paths waiting to save from Redux state
  const modifiedPathsWaitingToSave = useSelector(getModifiedPathsWaitingToSave);

  // State to track if this field is recalculating due to dependency changes
  const [isRecalculating, setIsRecalculating] = useState(false);

  // Cross-reference loading dependencies with modified paths to determine if recalculating
  useEffect(() => {
    if (!loadingDependencies || loadingDependencies.length === 0) {
      setIsRecalculating(false);
      return;
    }

    // Check if any of the loading dependencies are in the modified paths waiting to save
    const hasMatchingDependency = loadingDependencies.some(dependency => modifiedPathsWaitingToSave.includes(dependency));
    setIsRecalculating(hasMatchingDependency);
  }, [loadingDependencies, modifiedPathsWaitingToSave, moduleName]);

  // Make sure updates from the sidebar are also applied to the DOM
  useEffect(() => {
    if (currentValue !== undefined && node.innerText !== formattedValue && (document.activeElement !== node || wasUndoRedo)) {
      node.innerText = formattedValue;
    }
  }, [currentValue, formattedValue, node, wasUndoRedo]);

  // Apply visual feedback when recalculating
  useEffect(() => {
    if (isRecalculating) {
      node.classList.add('is-recalculating');
    } else {
      node.classList.remove('is-recalculating');
    }
  }, [isRecalculating, node]);
  return null;
};
export default ReadOnlyFieldEditor;